import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/supply-chain-mapping/supply-chains' ||
      location.pathname === '/supply-chain-mapping/supply-chains/'
    ) {
      throw redirect({ to: '/supply-chain-mapping/supply-chains/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/SupplyChainsLayout'),
    'SupplyChainsLayout',
  ),
});
